import { FormikProps, useFormikContext } from 'formik';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { FieldType } from '../types';
import { SelectField } from './SelectField';
import { FieldLabelWithFallback } from './FieldLabelWithFallback';

const IsOwnerOrOfficerField = ({
  itemData,
  value,
  locale,
  isNeedToMoveLabelOutOfInput,
}: {
  itemData: FieldType;
  value: any;
  locale: string;
  displayLabel: string;
  isNeedToMoveLabelOutOfInput: boolean;
}) => {
  const formik: FormikProps<any> = useFormikContext();

  const fieldsKeysToPopulate = ['firstName', 'lastName', 'email'];
  const pcFirstName = _.get(formik, 'values.firstName', '');
  const pcLastName = _.get(formik, 'values.lastName', '');
  const pcFullName = `${pcFirstName} ${pcLastName}`;

  const label = (
    <FieldLabelWithFallback
      values={{ full_name: pcFullName }}
      fieldLabel={itemData.config.fieldLabel}
      displayLabel={itemData.config.displayLabel}
    />
  );

  //TODO: usePrevious custom hook
  useEffect(() => {
    if (formik.values.isOwnerOrOfficer === '') {
      // not set yet
      return;
    }
    if (formik.values.isOwnerOrOfficer) {
      _.forEach(fieldsKeysToPopulate, (fieldKey) => {
        const pcValue = _.get(formik, `values.${fieldKey}`, '');
        formik.setFieldValue(`owners[0].${fieldKey}`, pcValue, false);
      });
    } else {
      _.forEach(fieldsKeysToPopulate, (fieldKey) => {
        formik.setFieldValue(`owners[0].${fieldKey}`, '', false);
      });
    }
  }, [formik.values.isOwnerOrOfficer]);

  return (
    <SelectField
      value={value}
      locale={locale}
      itemData={itemData}
      displayLabel={label}
      isNeedToMoveLabelOutOfInput={isNeedToMoveLabelOutOfInput}
    />
  );
};

export { IsOwnerOrOfficerField };
